import axios from 'axios';
import { authenticationService } from '../services/authentication.service';
import { ResponseRequestGeneric } from 'components/Types/GeneralTypes';

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                authenticationService.logout();
                //location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}


export function hadleAxiosError(error: any): string {
    var mensaje: string = ""
    if (axios.isAxiosError(error) && error.response) {
        mensaje = error.response.data;
    }
    else {
        mensaje = "No se pudo establecer contacto con el servidor. Intente más tarde;"
    }
    return mensaje;
}



export function hadleAxiosErrorResponse<TEntity>(error: any): ResponseRequestGeneric<TEntity> {
    var resultado: ResponseRequestGeneric<TEntity> = {
        status: -1
    }
    
    var mensaje:string|undefined = ""
    if(axios.isAxiosError(error) && error.response ){
        if(error.response.status === 500){
            mensaje = undefined;
        }
        else if(error.response.status === 401){
            mensaje = "No está autorizado a realizar la acción"
        }
        else{
            mensaje = error.response.data;
        }
        resultado.status = error.response.status;
    }
    else {
        mensaje = "No se pudo establecer contacto con el servidor. Intente más tarde"
    }
    resultado.errorMessage = mensaje;
    return resultado;
}

export async function handleAxiosErrorResponseBlob<TEntity>(error: any) {
    var mensaje = "";

    

    var resultado: ResponseRequestGeneric<TEntity> = {
        status: -1
    }

    if (error.response?.data instanceof Blob) {
        mensaje = await error.response.data.text();
        resultado.status = error.response.status;
    }
    else if (axios.isAxiosError(error) && error.response) {
        mensaje = error.response.data;
        resultado.status = error.response.status;
    }
    else {
        mensaje = "No se pudo establecer contacto con el servidor. Intente más tarde;"
    }
    resultado.errorMessage = mensaje;
    return resultado;
}



